import { Box, Grid } from "@mui/material";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";
import StlapFooter from "../../CustomComponents/StlapFooter";
import {
  ApplicationInfoListColumn,
  applicantInfoListData,
} from "./ApplicationInfoHelper";
import CustomSpinner from "../../CustomComponents/CustomSpinner";
import { useDispatch } from "react-redux";
import { SpinnerReduerAction } from "../../Store/spinner/SpinnerReducer";

const ApplicantList = () => {
  const dispatch = useDispatch();
  const [columnData, setColumnData] = useState([]);

  useEffect(() => {
    loadApplicantInfoList();
  }, []);

  const loadApplicantInfoList = async () => {
    dispatch(SpinnerReduerAction.updateSpinnerFlag(true));
    let newAxiosBase = { ...axios };
    newAxiosBase.defaults.baseURL =
      process.env.REACT_APP_STLAP_LOS_DATA_BACKEND;
    const response = await newAxiosBase.post("/stlap/getApplicantDetails");
    applicantInfoListData(response.data).then((v) => setColumnData(v));
    dispatch(SpinnerReduerAction.updateSpinnerFlag(false));
  };

  return (
    <>
      <CustomSpinner />
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <AccordianContainer
          id="accord"
          title="Applicant Information List"
          initialOpen={true}
        >
          <Box sx={{ marginTop: "-0.5%" }}>
            <CustomDataGrid
              noDataMessage="No Data"
              rows={columnData}
              columns={ApplicationInfoListColumn}
              pageSize={15}
              pageSizeOptions={[20]}
              gridLazyLoad={() => {}}
              gridHeight={500}
              getRowId={(row) => row.internalapplicationid}
              onCellKeyDown={(event, param) => {
                (param.key === "e" || param.key === "E") &&
                  param.preventDefault();
              }}
            />
          </Box>
        </AccordianContainer>
      </Box>
      <StlapFooter />
    </>
  );
};

export default ApplicantList;
